export enum FavouriteItemType {
  ContentGroup = 'content_group',
  FileGroup = 'file_group',
  Content = 'content',
  Competence = 'competence'
}
